export default __webpack_public_path__ + "static/media/quote_icon.4069766d.svg";